import {all} from 'redux-saga/effects'
import {combineReducers} from 'redux'
import userReducer from '../../app/utility/redux/reducer/user'
import * as auth from '../../app/modules/auth'

export const rootReducer = combineReducers({
  auth: auth.reducer,
  userReducer: userReducer
})

export type RootState = ReturnType<typeof rootReducer>

export function* rootSaga() {
  yield all([auth.saga()])
}
